import React from 'react';

export default function Description({ job, onClose }) {
  return (
    <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50'>
      <div className='bg-white p-6 rounded-lg w-4/5 max-w-2xl shadow-lg'>
        {/* Job Title and Company */}
        <h2 className="text-2xl font-bold mb-2 text-blue-800">{job.title}</h2>
        <p className="text-lg font-medium text-gray-700 mb-4">{job.company}</p>

        {/* Job Highlights */}
        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2 text-blue-600">Job Highlights</h3>
          <ul className="list-disc list-inside text-gray-600">
            <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
            <li>Proin vehicula urna ac libero auctor feugiat.</li>
            <li>Fusce volutpat metus ac ligula hendrerit tincidunt.</li>
          </ul>
        </div>

        {/* Job Description */}
        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2 text-blue-600">Job Description</h3>
          <p className="text-gray-600 leading-relaxed">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vehicula, libero sit amet bibendum fringilla, lorem nunc rhoncus eros, 
            vitae interdum augue purus at nulla. Vivamus vitae est id purus facilisis facilisis. Duis auctor, ipsum ut aliquam vulputate, 
            velit eros fermentum justo, a hendrerit dui sem in turpis.
          </p>
        </div>

        {/* Responsibilities */}
        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2 text-blue-600">Responsibilities</h3>
          <ul className="list-disc list-inside text-gray-600">
            <li>Ut vel urna ut purus hendrerit gravida.</li>
            <li>Curabitur posuere nunc at tortor euismod, quis tempor leo convallis.</li>
            <li>Aenean ultricies sapien nec nisi faucibus, id vulputate ligula tincidunt.</li>
          </ul>
        </div>

        {/* Requirements */}
        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2 text-blue-600">Requirements</h3>
          <ul className="list-disc list-inside text-gray-600">
            <li>Bachelor's degree in relevant field or equivalent experience.</li>
            <li>Strong problem-solving skills and attention to detail.</li>
            <li>Excellent communication and teamwork abilities.</li>
          </ul>
        </div>

        {/* Footer with Close Button */}
        <div className="flex flex-row justify-between">
          <button
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition-all"
            onClick={onClose}
          >
            Close
          </button>
          <button type='submit' className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition-all"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
}
